import React from "react";

const Profile = () => {
  return (
    <div>
      <h1>this is admin profile</h1>
    </div>
  );
};

export default Profile;
